import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SearchResultViewModel } from '@search/shared/models/search-view.model';
import { NewSearchViewModel } from '@app/new-search/models/new-search-view.model';
import { Product } from '@shared/models/product.model';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { PowerReviewRollupModel } from '@usf/ngrx-product/lib/models/power-review-product.model';
import { SearchPageType } from '@app/new-search/models/search-page-type.enum';
import { searchLoadingState } from '@usf/ngrx-product';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-new-search-result',
  templateUrl: './new-search-result.component.html',
  styleUrls: ['./new-search-result.component.scss'],
})
export class NewSearchResultComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;
  @Input() newSearchViewModel: NewSearchViewModel;
  @Input() itemHeights: number[];
  @Input() pwrRatingStarsMap: Map<string, PowerReviewRollupModel>;
  @Input() isTouchExperience: boolean;
  @Input() itemsSelectable: boolean;
  @Input() replacementBaseProduct: SearchResultViewModel;
  @Input() isMultiSelectionEnabled = true;
  @Input() addMethod: string;

  @Output() selectionChange = new EventEmitter<Product[]>();
  @Output() scrolledIndexChange = new EventEmitter<number>();
  @Output() resultClicked = new EventEmitter<number>();
  @Output() handleReloadResults = new EventEmitter();

  mode = UsfProductCardModeEnum.defaultSearch;

  ngOnInit(): void {
    window.addEventListener('resize', () => {
      this.viewport?.checkViewportSize();
    });
  }

  scrollToIndex(index: number) {
    this.viewport?.scrollToIndex(index);
  }

  trackProductByIndex(index: number, product: SearchResultViewModel) {
    return product ? index : undefined;
  }

  updateSelection(selectedProduct?: SearchResultViewModel) {
    if (this.isMultiSelectionEnabled) {
      const selectedProducts = this.newSearchViewModel.products.filter(
        product => product.selected,
      );
      this.notifySelectionChange(selectedProducts);
    } else {
      this.updateSelectionExclusive(selectedProduct);
    }
  }

  updateSelectionExclusive(selectedProduct: SearchResultViewModel) {
    this.resetSelection(selectedProduct);
    // the check is in case the product was already seelected
    this.notifySelectionChange(
      selectedProduct.selected ? [selectedProduct] : [],
    );
  }

  resetSelection(selectedProduct: SearchResultViewModel) {
    this.newSearchViewModel?.products
      .filter(
        item =>
          item.productNumber != selectedProduct.productNumber && item.selected,
      )
      .forEach(item => (item.selected = false));
  }

  notifySelectionChange(selectedProducts: SearchResultViewModel[]) {
    this.selectionChange.emit(selectedProducts);
  }

  onScrolledIndexChange(index: number) {
    this.scrolledIndexChange.emit(index);
  }

  onResultClicked(index: number) {
    this.resultClicked.emit(index);
  }

  get SearchPageType(): typeof SearchPageType {
    return SearchPageType;
  }

  get SearchLoadingState(): typeof searchLoadingState {
    return searchLoadingState;
  }

  notFoundEmitter() {
    this.handleReloadResults.emit();
  }
}
